function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Sensor_or_marker_Online",
  "data-name": "Sensor or marker Online",
  transform: "translate(-320 -411)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14702",
  "data-name": "Group 14702",
  transform: "translate(3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Marker_and_beacon-T_T-sensor",
  "data-name": "Marker and beacon-T/T-sensor",
  transform: "translate(317 411)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14701",
  "data-name": "Group 14701",
  transform: "translate(4.624 11.7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14698",
  "data-name": "Group 14698"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14697",
  "data-name": "Group 14697"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13399",
  "data-name": "Path 13399",
  d: "M23.6,25.8a1.061,1.061,0,0,1-1.5-1.5l2.2-2.2v.7h.9V20.7H23.1v.9h.7l-2.2,2.2a2,2,0,0,0,0,2.7,1.936,1.936,0,0,0,1.3.6,1.612,1.612,0,0,0,1.3-.6l1.2-1.2-.6-.6Z",
  transform: "translate(-21.075 -20.7)",
  fill: "rgba(23,36,79,0.5)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_14700",
  "data-name": "Group 14700",
  transform: "translate(3.625 2.475)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14699",
  "data-name": "Group 14699"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13400",
  "data-name": "Path 13400",
  d: "M29,25a1.612,1.612,0,0,0-.6-1.3,2,2,0,0,0-2.7,0l-1,1,.6.6,1-1a1.051,1.051,0,0,1,1.8.7.908.908,0,0,1-.3.7l-2.1,2.1v-.7h-.9v2.1h2.1v-.9h-.7l2.1-2.1A1.213,1.213,0,0,0,29,25Z",
  transform: "translate(-24.7 -23.175)",
  fill: "rgba(23,36,79,0.5)"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Path_13401",
  "data-name": "Path 13401",
  d: "M28.628,9H21.172A4.787,4.787,0,0,0,16.4,13.8V36.2A4.787,4.787,0,0,0,21.172,41h7.456A4.787,4.787,0,0,0,33.4,36.2V13.8A4.725,4.725,0,0,0,28.628,9Zm-7.357,1.5h7.456a3.32,3.32,0,0,1,3.281,3.3V17H17.991V13.7A3.235,3.235,0,0,1,21.271,10.5Zm10.637,7.3V34.3H17.991V17.8ZM28.628,39.5H21.172a3.32,3.32,0,0,1-3.281-3.3V35H31.909v1.2A3.256,3.256,0,0,1,28.628,39.5Z",
  transform: "translate(-16.4 -9)",
  fill: "rgba(23,36,79,0.5)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1197",
  "data-name": "Ellipse 1197",
  transform: "translate(331.92 437.25)",
  fill: "#00d168",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3.25,
  fill: "none"
})));

function SvgSensorOrMarkerOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.92,
    height: 34.25,
    viewBox: "0 0 19.92 34.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorOrMarkerOnline);
export default __webpack_public_path__ + "static/media/sensorOrMarkerOnline.6ff00e7c.svg";
export { ForwardRef as ReactComponent };